<script lang="ts">
    import { theme } from '$theme/theme.svelte';
    export let fill: string = $theme.colors.primary[200];
</script>

<svg
    {...$$restProps}
    width="43"
    height="28"
    viewBox="0 0 43 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <g clip-path="url(#clip0_3_73)">
        <path
            d="M21.5001 25.8773C12.062 25.8773 4.34739 20.5466 4.34739 14.0403C4.34739 7.534 12.0374 2.20333 21.5001 2.20333C30.9629 2.20333 38.6529 7.534 38.6529 14.0403C38.6529 20.5466 30.9629 25.8773 21.5001 25.8773ZM21.5001 0.753906C10.0923 0.753906 0.818359 6.64824 0.818359 14.0403C0.818359 21.4324 10.0923 27.3267 21.5001 27.3267C32.9079 27.3267 42.1819 21.368 42.1819 14.0403C42.1819 6.71266 32.9079 0.753906 21.5001 0.753906Z"
            {fill}
        />
        <path
            d="M22.4029 20.9653H20.1378C19.4238 20.9653 19.038 20.6513 19.038 20.0796V15.0066C19.038 14.6925 19.1693 14.5637 19.4894 14.5637H22.4029C24.2331 14.5637 25.7268 16.0051 25.7596 17.8007C25.7842 19.532 24.3726 20.9492 22.6081 20.9734C22.5424 20.9734 22.4768 20.9734 22.4029 20.9653ZM19.0462 8.00099C19.0462 7.42927 19.432 7.11523 20.146 7.11523H21.6315C23.1662 7.05081 24.4711 8.21841 24.5368 9.7242V9.84499C24.5121 11.3991 23.2154 12.6472 21.6315 12.6311H19.4976C19.1775 12.6311 19.0462 12.5023 19.0462 12.1882V8.00099ZM28.1561 13.6457C27.7047 13.4525 27.7047 13.388 28.1561 13.1384C29.3133 12.4379 30.0026 11.1817 29.9616 9.84499C29.9616 7.37291 26.6049 4.90083 21.2621 4.90083C18.1599 4.88472 15.1479 5.86711 12.6447 7.68695C12.1933 8.06541 12.259 8.25867 12.3903 8.38751L13.17 9.27327C13.4244 9.53094 13.5557 9.46653 13.687 9.33769C14.2697 8.89481 14.3354 9.14443 14.3354 9.65173V18.4288C14.3354 18.9361 14.2697 19.1938 13.687 18.7429C13.5557 18.614 13.4326 18.5496 13.17 18.8073L12.3329 19.7575C12.2015 19.9507 12.0784 20.1359 12.5955 20.458C15.1889 22.1973 18.2419 23.1475 21.377 23.1878C27.3846 23.1878 31.1434 20.7157 31.1434 17.4142C31.1927 15.1918 29.3215 14.1127 28.1561 13.6699"
            {fill}
        />
    </g>
    <defs>
        <clipPath id="clip0_3_73">
            <rect
                width="41.3636"
                height="26.4923"
                fill="white"
                transform="translate(0.818359 0.753906)"
            />
        </clipPath>
    </defs>
</svg>
